/**
 * This must be included before any of our scripts!
 *
 */

import {GemSettings} from 'app/utils/config/interface';

/**
 * This function sets the webpack public path based on the gem settings.
 * On deployed environments (FIT/FAT/PROD), this allows us to serve assets with webpack from CDN domain.
 * @param gemSettings
 * @returns void
 */
export const initPublicPath = (gemSettings: GemSettings) => () => {
    if (gemSettings.assetsDomain) {
        // eslint-disable-next-line camelcase
        __webpack_public_path__ = `${gemSettings.assetsDomain}${__webpack_public_path__}`;
    }
};
